export default {
  path: '/templates',
  name: 'templates.index',
  redirect: { name: 'templates.list-page' },
  component: () =>
    import(/* webpackChunkName: "templates" */ '@/views/templates/index.vue'),
  children: [
    {
      path: '/templates',
      name: 'templates.list-page',
      component: () =>
        import(
          /* webpackChunkName: "templates-list-page" */ '@/views/templates/TemplatesPage.vue'
        )
    },
    {
      path: '/template/:id',
      name: 'template.form-page',
      component: () =>
        import(
          /* webpackChunkName: "templates-form-page" */ '@/views/templates/TemplateFormPage.vue'
        )
    }
  ]
}
